import axios from 'axios';
import tsaEnvConfig from '../../../shared/utilities/apiUrl';
import { logNewrelicNoticeError } from '../../../shared/utilities/logger';

import { getHttpClientRequest, postHttpClientRequest} from '@vz/react-util';

const envConfig = tsaEnvConfig();
const runMode = process.env.NODE_ENV;

export const callAxios = async (url, method, data, headers) => {
  let response = false;

  const axiosConfig = {
    timeout: 300000, // 5 minutes
    headers: {
      ...headers,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      channelId: window._dg_channelId,
    },
  };
 /* istanbul ignore next */
  if(method?.toLowerCase() === "post") {
    const payload = data ? JSON.stringify(data) : '';
    await postHttpClientRequest(url, payload, axiosConfig)
    .then((resp, headers) => {
      response = { success: true, response: resp, headers };
    })
    .catch((err, headers) => {
      logNewrelicNoticeError(err, 'APIError');
      response = { success: false, error: err, headers };
    });
  } else if(method?.toLowerCase() === "get") {
    await getHttpClientRequest(url, axiosConfig)
    .then((resp, headers) => {
      response = { success: true, response: resp, headers };
    })
    .catch((err, headers) => {
      logNewrelicNoticeError(err, 'APIError');
      response = { success: false, error: err, headers };
    });
  }
  // console.log("axiosConfig", axiosConfig, url)
 /* istanbul ignore next */
  return response;
};

// feedback dropdown data + configuration data
export const additionalInfo = async (params) => {
   /* istanbul ignore next */
  const callMethod = runMode === 'development' ? 'get' : 'post';
  let response = null;
  try {
    response = await callAxios(
      envConfig.apiUrls.additionalInfo,
      callMethod,
      params
    );
  } catch (error) {
     /* istanbul ignore next */
    console.log('Feedback dropdown info call failed');
  }
   /* istanbul ignore next */
  return response;
};

export const getRecentPendingCase = async (params) => {
   /* istanbul ignore next */
  const callMethod = runMode === 'development' ? 'get' : 'post';
  let response = null;
  try {
    response = await callAxios(
      envConfig.apiUrls.recentPendingCase,
      callMethod,
      params
    );
  } catch (error) {
     /* istanbul ignore next */
    console.log("Recent pending case API failed : " + error);
  }
   /* istanbul ignore next */
  return response;
}